import { all, put, takeEvery } from "redux-saga/effects";
import { createApiSaga } from "redux-store/api-sagas";
import { addNewDevicesToDeviceStatusesAction } from "redux-store/device-statuses";
import { deviceService } from "service/device";

import {
  BULK_DOWNLOAD_DEVICE,
  BULK_DOWNLOAD_DEVICE_CUSTOM,
  BULK_EDIT_DEVICE,
  BULK_EDIT_DEVICE_SUCCESS,
  BULK_NEW_DEVICE,
  BULK_NEW_DEVICE_SUCCESS,
  CANCEL_UPGRADE,
  CANCEL_UPGRADE_SUCCESS,
  CLEAR_CACHE,
  CLEAR_WEBCAM_SNAPSHOT_CACHE,
  DELETE_DEVICES,
  DELETE_DEVICES_SUCCESS,
  DOWNGRADE_DEVICES,
  DOWNGRADE_DEVICES_SUCCESS,
  EDIT_DEVICE,
  EDIT_DEVICE_FLAGS,
  EDIT_DEVICE_FLAGS_SUCCESS,
  EDIT_DEVICE_PARAMS,
  EDIT_DEVICE_PARAMS_SUCCESS,
  EDIT_DEVICE_SUCCESS,
  GET_INTERNAL_STATE_DEVICE,
  GET_LOGS_DEVICE,
  GET_PLAYER_UPDATE_VERSIONS,
  GET_PLAYER_UPDATE_VERSIONS_SUCCESS,
  LOAD_DEVICES,
  LOAD_DEVICES_FAILURE,
  LOAD_DEVICES_SUCCESS,
  loadDevicesAction,
  NEW_DEVICE,
  NEW_DEVICE_SUCCESS,
  RESTART_DEVICE,
  TAKE_SCREEN_SHOT_DEVICE,
  TAKE_WEBCAM_SNAPSHOT_DEVICE,
  UPGRADE_DEVICES,
  UPGRADE_DEVICES_FIRMWARE,
  UPGRADE_DEVICES_FIRMWARE_SUCCESS,
  UPGRADE_DEVICES_SUCCESS,
} from "./actions";

const bulkCustomDownloadSaga = createApiSaga({
  fetchAction: BULK_DOWNLOAD_DEVICE_CUSTOM,
  service: deviceService.bulkCustomDownload,
  serviceName: "deviceService.bulkCustomDownload",
  reload: false,
});

const bulkDownloadSaga = createApiSaga({
  fetchAction: BULK_DOWNLOAD_DEVICE,
  service: deviceService.bulkDownload,
  serviceName: "deviceService.bulkDownload",
  reload: false,
});

const bulkEditDeviceSaga = createApiSaga({
  fetchAction: BULK_EDIT_DEVICE,
  successAction: BULK_EDIT_DEVICE_SUCCESS,
  serviceName: "deviceService.bulkEdit",
  reload: false,
  service: deviceService.bulkEdit,
});

const bulkRegisterDeviceSaga = createApiSaga({
  fetchAction: BULK_NEW_DEVICE,
  successAction: BULK_NEW_DEVICE_SUCCESS,
  serviceName: "deviceService.bulkRegister",
  reload: false,
  service: deviceService.bulkRegister,
});

const clearPlayerCacheSaga = createApiSaga({
  fetchAction: CLEAR_CACHE,
  service: deviceService.clearCache,
  serviceName: "deviceService.clearCache",
  reload: false,
});

const clearWebcamCacheSaga = createApiSaga({
  fetchAction: CLEAR_WEBCAM_SNAPSHOT_CACHE,
  service: deviceService.clearWebcamSnapshotCache,
  serviceName: "deviceService.clearWebcamSnapshotCache",
  reload: false,
});

const deleteDevicesSaga = createApiSaga({
  fetchAction: DELETE_DEVICES,
  successAction: DELETE_DEVICES_SUCCESS,
  service: deviceService.delete,
  serviceName: "deviceService.delete",
  reload: false,
});

const editDevicesSaga = createApiSaga({
  fetchAction: EDIT_DEVICE,
  successAction: EDIT_DEVICE_SUCCESS,
  serviceName: "deviceService.edit",
  service: deviceService.edit,
  reload: false,
});

const editDeviceFlagsSaga = createApiSaga({
  fetchAction: EDIT_DEVICE_FLAGS,
  successAction: EDIT_DEVICE_FLAGS_SUCCESS,
  service: deviceService.updateFlags,
  serviceName: "deviceService.updateFlags",
  reload: false,
});

const editDeviceParamsSaga = createApiSaga({
  fetchAction: EDIT_DEVICE_PARAMS,
  successAction: EDIT_DEVICE_PARAMS_SUCCESS,
  service: deviceService.updateParams,
  serviceName: "deviceService.updateParams",
  reload: false,
});

const getInternalStateDeviceSaga = createApiSaga({
  fetchAction: GET_INTERNAL_STATE_DEVICE,
  service: deviceService.getInternalState,
  serviceName: "deviceService.getInternalState",
  reload: false,
});

const getLogsDeviceSaga = createApiSaga({
  fetchAction: GET_LOGS_DEVICE,
  service: deviceService.getLogs,
  serviceName: "deviceService.getLogs",
  reload: false,
});

const reloadDevicesSaga = createApiSaga({
  fetchAction: LOAD_DEVICES,
  successAction: LOAD_DEVICES_SUCCESS,
  failureAction: LOAD_DEVICES_FAILURE,
  serviceName: "deviceService.load",
  service: deviceService.load,
  reload: true,
});

const newDeviceSaga = createApiSaga({
  fetchAction: NEW_DEVICE,
  successAction: NEW_DEVICE_SUCCESS,
  service: deviceService.register,
  serviceName: "deviceService.register",
  reload: false,
});

const restartDeviceSaga = createApiSaga({
  fetchAction: RESTART_DEVICE,
  service: deviceService.restartDevice,
  serviceName: "deviceService.restartDevice",
  reload: false,
});

const takeScreenShotDeviceSaga = createApiSaga({
  fetchAction: TAKE_SCREEN_SHOT_DEVICE,
  service: deviceService.takeScreenshot,
  serviceName: deviceService.takeScreenshot,
  reload: false,
});

const takeWebcamSnapshotDeviceSaga = createApiSaga({
  fetchAction: TAKE_WEBCAM_SNAPSHOT_DEVICE,
  service: deviceService.takeSnapshot,
  serviceName: deviceService.takeSnapshot,
  reload: false,
});

const upgradeDevicesSaga = createApiSaga({
  fetchAction: UPGRADE_DEVICES,
  successAction: UPGRADE_DEVICES_SUCCESS,
  service: deviceService.upgrade,
  serviceName: "deviceService.upgrade",
  reload: false,
});

const downgradeDevicesSaga = createApiSaga({
  fetchAction: DOWNGRADE_DEVICES,
  successAction: DOWNGRADE_DEVICES_SUCCESS,
  service: deviceService.downgrade,
  serviceName: "deviceService.downgrade",
  reload: false,
});

const cancelUpgradeSaga = createApiSaga({
  fetchAction: CANCEL_UPGRADE,
  successAction: CANCEL_UPGRADE_SUCCESS,
  service: deviceService.cancelUpgrade,
  serviceName: "deviceService.cancelUpgrade",
  reload: false,
});

const getPlayerUpdateVersionsSaga = createApiSaga({
  fetchAction: GET_PLAYER_UPDATE_VERSIONS,
  successAction: GET_PLAYER_UPDATE_VERSIONS_SUCCESS,
  service: deviceService.getPlayerUpdateVersions,
  serviceName: "deviceService.getPlayerUpdateVersions",
  reload: false,
});

const upgradeDevicesFirmwareSaga = createApiSaga({
  fetchAction: UPGRADE_DEVICES_FIRMWARE,
  successAction: UPGRADE_DEVICES_FIRMWARE_SUCCESS,
  service: deviceService.upgradeFirmware,
  serviceName: "deviceService.upgradeFirmware",
  reload: false,
});

function* _addDevices(action) {
  const devices =
    action.type === NEW_DEVICE_SUCCESS
      ? [action.payload.data]
      : action.payload.data;

  yield all([
    put(loadDevicesAction(devices)),
    put(addNewDevicesToDeviceStatusesAction(devices)),
  ]);
}

function* addNewDevicesSaga() {
  yield takeEvery(
    [BULK_EDIT_DEVICE_SUCCESS, BULK_NEW_DEVICE_SUCCESS, NEW_DEVICE_SUCCESS],
    _addDevices,
  );
}

const deviceSagas = [
  addNewDevicesSaga(),
  bulkCustomDownloadSaga(),
  bulkDownloadSaga(),
  bulkEditDeviceSaga(),
  bulkRegisterDeviceSaga(),
  clearPlayerCacheSaga(),
  clearWebcamCacheSaga(),
  deleteDevicesSaga(),
  editDevicesSaga(),
  editDeviceFlagsSaga(),
  editDeviceParamsSaga(),
  getInternalStateDeviceSaga(),
  getLogsDeviceSaga(),
  newDeviceSaga(),
  reloadDevicesSaga(),
  restartDeviceSaga(),
  takeScreenShotDeviceSaga(),
  takeWebcamSnapshotDeviceSaga(),
  upgradeDevicesSaga(),
  upgradeDevicesFirmwareSaga(),
  downgradeDevicesSaga(),
  cancelUpgradeSaga(),
  getPlayerUpdateVersionsSaga(),
];

export {
  _addDevices,
  addNewDevicesSaga,
  bulkCustomDownloadSaga,
  bulkDownloadSaga,
  bulkEditDeviceSaga,
  bulkRegisterDeviceSaga,
  clearPlayerCacheSaga,
  clearWebcamCacheSaga,
  deleteDevicesSaga,
  deviceSagas,
  editDevicesSaga,
  editDeviceFlagsSaga,
  editDeviceParamsSaga,
  getInternalStateDeviceSaga,
  getLogsDeviceSaga,
  newDeviceSaga,
  restartDeviceSaga,
  takeScreenShotDeviceSaga,
  takeWebcamSnapshotDeviceSaga,
  reloadDevicesSaga,
  upgradeDevicesSaga,
  upgradeDevicesFirmwareSaga,
  downgradeDevicesSaga,
  cancelUpgradeSaga,
};
